import React from 'react'
import PropTypes from 'prop-types'

import { AccountAlert } from '../../Assets'
import styles from './ScrollAbleTabs.module.css'

const ScrollableTabs = ({ bgColor, hover, servicesTags }) => {
    return (
        <div
            style={{
                alignItems: 'center',
                display: 'flex',
                flexGrow: '1',
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <div className={styles.tabWrapper}>
                {servicesTags?.map((tag, index) => (
                    <div
                        id="1"
                        onClick={function noRefCheck() {}}
                        className={styles.scrollTabsBar}
                        key={index}
                        style={{ background: hover && bgColor }}
                    >
                        {/* <img src={AccountAlert} /> */}
                        {/* <img
                            src={tag?.service?.ImgURL + tag?.service?.icon}
                            width={16}
                            height={16}
                            alt=""
                        /> */}
                        {tag?.service?.title}
                    </div>
                ))}

                {/* {!servicesTags &&
                    [1, 2, 3, 45, 6, 78, 9, 78].map((tag, index) => {
                        return (
                            <div
                                id="1"
                                onClick={function noRefCheck() {}}
                                className={styles.scrollTabsBar}
                                key={index}
                                style={{ background: hover && bgColor }}
                            >
                                <img src={AccountAlert} alt="" />
                                Services
                            </div>
                        )
                    })} */}
            </div>
        </div>
    )
}

ScrollableTabs.propTypes = {
    servicesTags: PropTypes.array.isRequired,
    hover: PropTypes.bool,
    bgColor: PropTypes.string,
}

export default ScrollableTabs
